import { useState } from 'react';
import { globalHistory } from '@reach/router';

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

function UseFormValidation(initialState) {
  const [values, setValues] = useState(initialState);
  const [success, setSuccess] = useState(false);
  const [formError] = useState(null);
  const path = globalHistory.location.pathname;

  function handleChange(event) {
    event.persist();
    setValues((previousValues) => ({
      ...previousValues,
      [event.target.name]: event.target.value,
    }));
  }
  //--
  function handleSubmit(event) {
    event.preventDefault();
    console.log(values);
    const form = event.target;
    const formName = form.getAttribute('name').toString();
    fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': `${formName}`,
        ...values,
      }),
    })
      .then(() => setSuccess(true))
      .catch((error) => {
        console.log('This is the error');
        alert(error);
      });
  }

  return {
    handleChange,
    handleSubmit,
    values,
    success,
    formError,
  };
}

export default UseFormValidation;
